import React from 'react'
import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'
import SongwriterAccountCard from '@Components/Cards/AccountCard/SongwriterAccountCards/SongwriterAccountCard'
import { ResultPage } from '@Entities/result-page'
import { observer } from 'mobx-react'
import './index.scss'

interface SongwriterAccountCardsProps {
    allSongwriters: ResultPage<SongwriterSummary> | undefined
}

const SongwriterAccountCards = (props: SongwriterAccountCardsProps) => {
    const { allSongwriters } = props
    return (
        <section className="songwriter-cards">
            {allSongwriters?.content.map((item: SongwriterSummary) => (
                <SongwriterAccountCard key={item.id} songwriterData={item} />
            ))}
        </section>
    )
}
export default observer(SongwriterAccountCards)
